import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./_app.scss";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import { getUser } from "../api/userApi";
import { initializeDataLayer } from "../api/gtm-analytics";
import { getEnv, getPartition } from "../config/appConfig";
import { connect } from "react-redux";
import { loadUser } from "../actions/userActions";
import HomePage from "./pages/HomePage";
import Alert from "@cx/ui/Alert";
import { Trans } from "react-i18next";
import Button from "@cx/ui/Button";
import LoadingIndicatorCentered from "./reusableComponents/LoadingIndicatorCentered";
import {
  displayAlertMessage,
  hideAlertMessage,
  ERROR_MESSAGES
} from "../actions/statusActions";
import { MESSAGE_TYPE, MESSAGE_SEVERITY } from "../utils/MessageTypes";

const App = (props) => {
  const [attemptCount, setAttemptCount] = useState(0);
  const [userFound, setUserFound] = useState(false);
  const [userLoadFailed, setUserLoadFailed] = useState(false);
  const [ldErrorShown, setLdErrorShown] = useState(false);
  useEffect(() => {
    getUser()
      .then(async (user) => {
        // initialize gtm data layer
        initializeDataLayer(getEnv(), user);

        props.loadUser(user.data);
        const ffUser = {
          key: user.data.id,
          custom: {
            id: user.data.identity.username,
            partition: getPartition(),
            solutionLinks: user.data.solutionLinks
              ? user.data.solutionLinks
                  .map((lnk) => lnk.solutionId.toLowerCase())
                  .join(",")
              : "NOT_LINKED"
          }
        };
        try {
          await props.ldClient.identify(ffUser);
        } catch (error) {
          // Display LaunchDarkly warning to user only the first time
          if (!ldErrorShown) {
            props.displayAlertMessage({
              payload: ERROR_MESSAGES.LAUNCH_DARKLY_INITIALIZATION_FAILURE,
              type: MESSAGE_TYPE.ALERT,
              severity: MESSAGE_SEVERITY.WARN
            });
            setLdErrorShown(true);
          }
        }
        setUserFound(true);
      })
      .catch((reason) => {
        // eslint-disable-next-line no-console
        console.error("Failed to get user: " + reason);
        setUserLoadFailed(true);
      });
  }, [props.ldClient, props.loadUser, attemptCount]);

  if (userFound) {
    return (
      <div className="main-layout">
        <div id="wrapper" className="content">
          <HomePage />
        </div>
      </div>
    );
  }

  if (userLoadFailed) {
    return (
      <div>
        <br />
        <Alert htmlId="load-failed-message" type="danger">
          <h5>
            <Trans i18nKey="messages.errors.user-service-error" />
          </h5>
        </Alert>
        <Button
          buttonStyle="secondary"
          htmlId="try-again-button"
          onClick={() => setAttemptCount(attemptCount + 1)}
        >
          <Trans i18nKey="common.try-again" />
        </Button>
      </div>
    );
  }

  return (
    <div>
      <LoadingIndicatorCentered htmlId="ff-load-pending" size="large" />
    </div>
  );
};

App.propTypes = {
  alertMessages: PropTypes.array,
  displayAlertMessage: PropTypes.func,
  hideAlertMessage: PropTypes.func,
  ldClient: PropTypes.shape({
    identify: PropTypes.func.isRequired
  }).isRequired,
  loadUser: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  alertMessages: state.statusReducer ? state.statusReducer.alertMessages : []
});

const mapDispatchToProps = {
  loadUser,
  displayAlertMessage,
  hideAlertMessage
};

const connectedApp = connect(mapStateToProps, mapDispatchToProps)(App);
export default withLDConsumer({})(connectedApp);
